import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  Autocomplete,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import fetchcity from "../../common/fetchcity";
import SearchIcon from "@mui/icons-material/Search";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { toast } from "react-hot-toast";
import { OrbitProgress, BlinkBlur } from "react-loading-indicators";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

const AddCashRequestModal = ({ setActiveItem }) => {
  const pettyCashTypes = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashTypes;
  delete pettyCashTypes?.inverted;
  const pettyCashStatus = JSON.parse(localStorage.getItem("catalogValues"))
    .pettyCashStatus.inverted;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const token = localStorage.getItem("token");
  const [type, setType] = useState("");
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState(null);
  const [hubs, setHubs] = useState(null);
  const [hub, setHub] = useState(null);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [imageData, setImageData] = useState(null);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [bookingId, setBookingId] = useState(null);
  const defaultInputs = [
    { name: "Amount", type: "input", disable: false, subCategory: [] },
    { name: "Description", type: "input", disable: false, subCategory: [] },
  ];

  const [formDefaultInputs, setFormDefaultInputs] = useState(defaultInputs);
  const [dataforSubCategory, setDataforSubCategory] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [dataForIssueID, setDataForIssueId] = useState(null);
  const [vehicleListings, setVehicleListings] = useState([]);
  const [vehicleId, setVehicleId] = useState(null);

  const settings = {
    dots: true,
    infinite: imageData?.length > 1, // only loop if more than one
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  const handleSubCategory = async () => {
    let key = Object.keys(pettyCashTypes).find(
      (k) => pettyCashTypes[k] === "Pickup And Delivery Reimbursement"
    );
    try {
      const response = await fetch(
        `${apiUrl}/api/catalogs/get-all?parentId=${key}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setDataforSubCategory(data.entities?.rows);
      }
    } catch (error) {
      return console.error("Error fetching sub category:", error);
    }
  };

  useEffect(() => {
    const extraFields = [
      {
        name: "Search Vehicle Number",
        type: "autocomplete",
        disable: false,
        subCategory: [],
      },
      { name: "Vehicle Name", type: "input", disable: true, subCategory: [] },
      { name: "Vehicle Number", type: "input", disable: true, subCategory: [] },
      {
        name: "Issue ID",
        type: "dropdown",
        disable: false,
        subCategory: Array.isArray(dataForIssueID)
          ? dataForIssueID.map((item) => {
              return {
                value: item?.code,
                id: item?.id,
              };
            })
          : [],
      },
    ];
    switch (type) {
      case "Fuel Charges ":
        setFormDefaultInputs((prev) => [
          ...prev,
          {
            name: "Fuel Card No",
            type: "input",
            disable: false,
            subCategory: [],
          },
          ...extraFields,
        ]);
        break;
      case "Vehicle Expenses":
        setFormDefaultInputs((prev) => [...prev, ...extraFields]);
        break;
      case "Pickup And Delivery Reimbursement":
        const subCategoryFields = [
          {
            name: "Delivery Type",
            type: "dropdown",
            disable: false,
            subCategory:
              dataforSubCategory?.map((item) => ({
                value: item?.value,
                id: item?.id,
              })) || [],
          },
        ];

        setFormDefaultInputs((prev) => [
          ...prev,
          {
            name: "Booking Id",
            type: "input",
            disable: false,
            subCategory: [],
          },
          ...subCategoryFields, // dynamically created input fields
          ...extraFields,
        ]);
        break;
    }
  }, [type]);

  useEffect(() => {
    setFormDefaultInputs((prevInputs) =>
      prevInputs.map((field) => {
        if (field.name === "Issue ID") {
          return {
            ...field,
            subCategory: Array.isArray(dataForIssueID)
              ? dataForIssueID.map((item) => ({
                  value: item?.code,
                  id: item?.id,
                }))
              : [],
          };
        }
        return field;
      })
    );
  }, [dataForIssueID]);

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  // const getVehicleDetails = async (name) => {
  //   try {
  //     const response = await fetch(
  //       `${apiUrl}/api/vehicles?licensePlate=${inputValues[name]}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Accept: "application/json",
  //         },
  //       }
  //     );
  //     const data = await response.json();
  //     if (data?.statusCode === "0100") {
  //       // await getVehicleIssuesApi(data?.entities?.rows[0]?.id);
  //       // setInputValues((prev) => ({
  //       //   ...prev,
  //       //   ["Vehicle Name"]: data?.entities?.rows[0]?.name,
  //       //   ["Vehicle Number"]: data?.entities?.rows[0]?.licensePlate,
  //       // }));
  //     }
  //     return data;
  //   } catch (error) {
  //     return console.error("Error fetching vehicle license plate:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getVehicleIssuesApi = async (vehicleID) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleissues?limit=100&status=523&vehicleId=${vehicleID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setDataForIssueId(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching vehicle issues api:", error);
    }
  };

  useEffect(() => {
    fetchcity().then((response) => {
      if (response) {
        setCities(response);
      }
    });
    handleSubCategory();
  }, []);

  const handleChange = (event) => {
    setFormDefaultInputs(defaultInputs);
    setType(event.target.value);
  };

  const handleCityChange = (event) => {
    setHub(null);
    const value = event.target.value;
    setCity(value);
    getHubNames(value);
  };

  const handleHubChange = async (event) => {
    setHub(event.target.value);
    await getVechileListings(event.target.value);
  };

  const getVechileListings = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicles?limit=500&offset=0&hubId=${id}`,
        {
          method: "GET",
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVehicleListings(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  useEffect(() => {
    if (vehicleId) {
      getVehicleIssuesApi(vehicleId?.id);
      setInputValues((prev) => ({
        ...prev,
        ["Vehicle Name"]: vehicleId?.name,
        ["Vehicle Number"]: vehicleId?.licensePlate,
      }));
    }
  }, [vehicleId]);

  const handleInputValueChanges = (label, event) => {
    const value = event.target.value;
    const key = label?.name;

    if (key) {
      setInputValues((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const handleAddRequestSubmit = async () => {
    let cashForType = Number(
      Object.keys(pettyCashTypes).find((key) => pettyCashTypes[key] === type)
    );

    let subCategory = Number(
      Object.keys(pettyCashTypes).find((key) => pettyCashTypes[key] === type)
    );

    if (
      city &&
      hub &&
      imageData &&
      inputValues?.Amount &&
      inputValues?.Description
    ) {
      const submitRequest = async () => {
        const response = await fetch(`${apiUrl}/api/pettycashes`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            amount: inputValues?.Amount,
            cityId: city,
            cityName: cities[city],
            registrationNo: inputValues["Vehicle Number"],
            vehicleName: inputValues["Vehicle Name"],
            workorderId: "",
            bookingId: inputValues["Booking Id"],
            issueId: inputValues["Issue ID"],
            pettyCashStatus: pettyCashStatus?.requested,
            cashFor: cashForType,
            description: inputValues?.Description,
            billAttachment: imageData?.fileName,
            requestBy: profile?.name,
            requestByEmail: profile?.email,
            hubId: hub,
            hubName: hubs[hub]?.hubName,
            attachments: JSON.stringify(imageData),
            subCategory:
              inputValues["Delivery Type"] === "Drop"
                ? dataforSubCategory[1].id
                : dataforSubCategory[0].id,
            fuelCardNo: inputValues["Fuel Card No"],
            bookingCode: inputValues["Booking Id"],
          }),
        });

        const data = await response.json();
        if (data?.statusCode === "0100") {
          // Reset form
          setType("");
          setCity(null);
          setHub(null);
          setHubs(null);
          setInputValues({});
          setImage(null);
          setImageData(null);
          setActiveItem("View All");
          localStorage.setItem("status", true);
          return "Request added successfully";
        } else {
          throw new Error(data?.message || "Failed to submit request");
        }
      };

      // Wrap with toast.promise
      toast.promise(submitRequest(), {
        loading: "Submitting...",
        success: (msg) => msg,
        error: (err) => err.message || "Submission failed",
      });
    } else if (!city) {
      toast.error("Select City");
    } else if (!hub) {
      toast.error("Select Hub");
    } else if (!imageData) {
      toast.error("Upload Image");
    } else if (!inputValues?.Amount) {
      toast.error("Fill the amount");
    } else if (!inputValues?.Description) {
      toast.error("Enter the description");
    } else if (!inputValues["Booking Id"]) {
      toast.error("Enter the Booking Id");
    } else {
      toast.error("Fill the details");
    }
  };

  const getHubNames = async (value) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/hubs?limit=100&cityId=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setHubs(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleUploadImage = async (event) => {
    setLoading(true);
    const files = event.target.files;
    const formData = new FormData();
    formData.append("entityName", "pettyCash");
    formData.append("fileTags", "vehicle");
    Object.values(files).forEach((file) => {
      formData.append("files", file);
    });

    try {
      const response = await fetch(`${apiUrl}/fileapi/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data) {
        setImageData(data?.uploaded);
        setImage(data?.uploaded[0]?.url);
        setLoading(false);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  return (
    <div className="h-full md:min-h-screen p-4">
      <div className="my-4 text-xl md:text-2xl font-bold">
        <h1>Add Cash Requests</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Left 2/3 Section */}
        <div className="md:col-span-2 border shadow-lg rounded-lg p-4 bg-white">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-4">
            {/* Type Select */}
            <FormControl fullWidth>
              <InputLabel id="type-label">Type</InputLabel>
              <Select
                labelId="type-label"
                value={type}
                label="Type"
                onChange={handleChange}
              >
                {pettyCashTypes &&
                  Object.values(pettyCashTypes).map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="city-label">City</InputLabel>
              <Select
                labelId="city-label"
                value={city}
                onChange={handleCityChange}
                label="City"
              >
                {cities &&
                  Object.entries(cities).map(([key, value]) => (
                    <MenuItem key={key} value={key}>
                      {value}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="hub-label">Hub</InputLabel>
              <Select
                onChange={handleHubChange}
                labelId="hub-label"
                autoWidth
                label="Hub"
              >
                {hubs ? (
                  hubs.map((item, index) => (
                    <MenuItem key={index} value={item?.id}>
                      {item?.hubName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">
                    <em>Select City First</em>
                  </MenuItem>
                )}
              </Select>
            </FormControl>

            {type &&
              formDefaultInputs?.map((label, index) => {
                return label?.type === "input" ? (
                  <TextField
                    key={index}
                    InputLabelProps={{ shrink: true }}
                    label={label?.name}
                    autoComplete="off"
                    value={inputValues[label.name] || ""}
                    onChange={(event) => {
                      handleInputValueChanges(label, event);
                    }}
                    fullWidth
                    InputProps={{
                      readOnly: label?.disable,
                      endAdornment: label?.name === "Search Vehicle Number" && (
                        <InputAdornment position="end">
                          <IconButton
                          // onClick={() =>
                          //   getVehicleDetails("Search Vehicle Number")
                          // }
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                ) : label?.type === "dropdown" ? (
                  <FormControl fullWidth>
                    <InputLabel id="drop-label">{label?.name}</InputLabel>
                    <Select
                      key={index}
                      labelId="drop-label"
                      value={inputValues[label.name] || ""}
                      onChange={(event) => {
                        handleInputValueChanges(label, event);
                      }}
                      label={label?.name}
                    >
                      {label?.subCategory &&
                        label?.subCategory.map((item, index) => (
                          <MenuItem key={index} value={item?.value}>
                            {item?.value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                ) : (
                  label?.type === "autocomplete" && (
                    <Autocomplete
                      fullWidth
                      freeSolo
                      options={vehicleListings} // Add your options here, e.g., ["ID001", "ID002"]
                      getOptionLabel={(option) => {
                        if (option && typeof option === "object") {
                          const name = option.name || "";
                          const id = option.id || "";
                          const licensePlate = option.licensePlate;
                          return `${name} - ${licensePlate} - ${id}`.trim();
                        }
                        return "";
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Search Vehicle No"
                          InputLabelProps={{ shrink: true }}
                          autoComplete="off"
                          // className="h-10"
                        />
                      )}
                      onChange={(event, newValue) => {
                        setVehicleId(newValue);
                      }}
                    />
                  )
                );
              })}
          </div>
        </div>

        <div className="border shadow-lg rounded-lg p-4 flex flex-col items-center justify-center bg-white w-full">
          {loading ? (
            <div className="flex flex-col items-center justify-center">
              {/* <OrbitProgress
                variant="spokes"
                color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]}
                size="medium"
                text="Image Uploading"
                textColor="#aeb7fb"
              /> */}

               <BlinkBlur color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]} />
            </div>
          ) : (
            <>
              <div className="max-w-xs w-full mb-4">
                {imageData?.length > 1 ? (
                  <Slider {...settings}>
                    {imageData.map((img, idx) => (
                      <div key={idx}>
                        <img
                          src={img?.url}
                          alt={`Preview ${idx}`}
                          className="w-full h-64 object-cover rounded"
                        />
                      </div>
                    ))}
                  </Slider>
                ) : (
                  imageData?.[0] && (
                    <img
                      src={imageData[0]?.url}
                      alt="Preview"
                      className="w-full h-64 object-cover rounded"
                    />
                  )
                )}
              </div>

              {type && (
                <div className="mt-6">
                  <Button
                    component="label"
                    variant="outlined"
                    startIcon={<CloudUploadIcon />}
                  >
                    Upload File
                    <VisuallyHiddenInput
                      type="file"
                      onChange={handleUploadImage}
                      multiple
                    />
                  </Button>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className="flex justify-center items-center mt-6">
        <button
          className="bg-blue-600 text-white px-6 py-2 rounded-md font-bold hover:bg-blue-800 transition text-sm md:text-base"
          onClick={handleAddRequestSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default AddCashRequestModal;
